import React, { useState } from 'react'
import { useQueryClient } from 'react-query'
import { useHistory } from 'react-router-dom'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { createDocument, updateDocumentByID } from '../../lib/RestApi/customApiHandler'

export default function AddBusinessType({ businessType: businessTypeData }) {
  const queryClient = useQueryClient()
  const history = useHistory()
  const [businessType, setBusinessType] = useState({
    name: businessTypeData ? businessTypeData.name : '',
  })

  const data = [{ label: 'Business Type Name', value: businessType.name, name: 'name' }]

  const [loading, setLoading] = useState(false)

  const handleClick = () => {
    setLoading(true)

    if (businessTypeData) {
      updateDocumentByID('/business-Type', businessTypeData._id, businessType)
      queryClient.invalidateQueries('business-Type')
      setLoading(false)
    } else {
      createDocument('/business-Type', businessType)
      queryClient.invalidateQueries('business-type')
      setLoading(false)
    }

    history.push('/business-Type')
  }

  return (
    <CustomAddPage
      heading="Business Type"
      redirect={'BUSINESS_TYPE'}
      currentData={businessType}
      loading={loading}
      state={businessType}
      setState={setBusinessType}
      handleClick={handleClick}
      inputFields={data}
    />
  )
}
